import React, { useEffect, useState } from "react";
import Preloader from "../helper/Preloader";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import HeaderTwo from "../components/HeaderTwo";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import { handleError } from "../utils/functions";
import SubmitButton from "../components/SubmitButton";
import { toast } from "react-toastify";
import axiosInstance from "../config/axios.config";
import OTPInput from "react-otp-input";

const UserVerify = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      if (otp.length !== 6) {
        toast.error("Completely Fill Otp");
        return;
      }

      setIsSubmitting(true);
      const { data: res } = await axiosInstance.post("/user/verify", {
        otp,
        token: searchParams.get("token"),
      });
      if (!res.error) {
        toast.success(res.message);
        navigate(`/user-login`);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const [seconds, setSeconds] = useState(59);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [otp, setOtp] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  });

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderTwo category={true} />

      <section className="account py-80">
        <div className="container">
          <form onSubmit={onSubmit}>
            <div className="row justify-content-center">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-body py-30 px-30">
                    {/* Personal Details Section */}
                    <h3 className="text-center mt-25 mb-2">
                      {t("verifyEmail")}
                    </h3>
                    <p className="text-center mb-30">
                      {t("enterVerificationCode")}
                    </p>
                    <div className="row">
                      <div className="d-flex justify-content-center">
                        <OTPInput
                          value={otp}
                          onChange={setOtp}
                          numInputs={6}
                          inputStyle={{
                            width: 40,
                            height: 40,
                            borderRadius: 4,
                          }}
                          renderSeparator={<span> - </span>}
                          renderInput={(props) => <input {...props} />}
                          inputType="tel"
                          placeholder={t("otpPlaceholder")}
                        />
                      </div>
                    </div>

                    <div className="mt-30 text-center">
                      <SubmitButton isSubmitting={isSubmitting}>
                        {t("verify")}
                      </SubmitButton>
                      <p className="mt-20">
                        {seconds > 0 ? (
                          <span>{t("resendOtpIn", { seconds })}</span>
                        ) : (
                          <span className="text-main font-medium">
                            {t("noOtpReceived")}{" "}
                            <button
                              className="underline"
                              onClick={() => {
                                setSeconds(59);
                              }}
                            >
                              {t("resendNow")}
                            </button>
                          </span>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>

      {/* FooterTwo */}
      <FooterTwo />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default UserVerify;
